// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NErc","label":"styles_label___Knpp"};